import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'success';

/** brand/components/Button: one primary per screen; success only for funded/approved; danger behind a confirmation. */
const VARIANTS: Record<Variant, string> = {
  primary: 'fl-btn--primary',
  secondary: 'fl-btn--secondary',
  danger: 'fl-btn--danger',
  ghost: 'fl-btn--ghost',
  success: 'fl-btn--success',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** `sm` (32px) is for dense desktop toolbars only; the default is the 44px touch target. */
  size?: 'md' | 'sm';
  busy?: boolean;
}

export function Button({
  variant = 'primary',
  size = 'md',
  busy = false,
  className = '',
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      className={`fl-btn ${VARIANTS[variant]} ${size === 'sm' ? 'fl-btn--sm' : ''} disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...rest}
    >
      {busy ? (
        <span
          className="size-4 animate-spin rounded-pill border-2 border-current border-t-transparent"
          aria-hidden
        />
      ) : null}
      {children}
    </button>
  );
}
